import RedirectHandler from 'Components/element/RedirectHandler';
import { Navigate, RouteObject } from 'react-router-dom';

export const REDIRECTS_ROUTES: RouteObject[] = [
   {
      path: '*',
      element: <RedirectHandler />,
   },
   {
      path: '/ru',
      element: <Navigate to="/" />,
   },
   {
      path: '/uk/info/data',
      element: <Navigate to="/" />,
   },
   {
      path: '/article/*',

      element: <Navigate to="/blog" />,
   },
   {
      path: '/ru/blog/*',
      element: <Navigate to="/blog" />,
   },

   {
      path: '/search/*',
      element: <Navigate to="/searchjob" />,
   },

   {
      path: '/employer/*',
      element: <Navigate to="/searchjob" />,
   },

   {
      path: '/ru/employer/*',
      element: <Navigate to="/searchjob" />,
   },

   {
      path: '/applicant/*',
      element: <Navigate to="/auth/employer-login" />,
   },

   {
      path: '/account/login',
      element: <Navigate to="/auth/employer-login" />,
   },
   {
      path: '/cabinet/help/',
      element: <Navigate to="/auth/employer-login" />,
   },
   {
      path: '/user/employerlogin',
      element: <Navigate to="/auth/employer-login" />,
   },

   {
      path: '/user/jobseekerlogin',
      element: <Navigate to="/auth/candidate-login" />,
   },
   {
      path: '/user/register/jobseeker',
      element: <Navigate to="/auth/candidate-register" />,
   },
];
